// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__8mTpH","content":"GlobalSearch_content__2V59G"};